/**
* Copyright 2012-2019, Plotly, Inc.
* All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
'use strict';

module.exports = {
  nodeTextOffsetHorizontal: 4,
  nodeTextOffsetVertical: 3,
  nodePadAcross: 10,
  sankeyIterations: 50,
  forceIterations: 5,
  forceTicksPerFrame: 10,
  duration: 500,
  ease: 'linear',
  cn: {
    sankey: 'sankey',
    sankeyLinks: 'sankey-links',
    sankeyLink: 'sankey-link',
    sankeyNodeSet: 'sankey-node-set',
    sankeyNode: 'sankey-node',
    nodeRect: 'node-rect',
    nodeCapture: 'node-capture',
    nodeCentered: 'node-entered',
    nodeLabelGuide: 'node-label-guide',
    nodeLabel: 'node-label',
    nodeLabelTextPath: 'node-label-text-path'
  }
};